export default __webpack_public_path__ + "static/media/LandingPage_BackgroundImage.390cd362.png";